<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" size="mini">添加产品</el-button>
      </el-col>
      <el-col :span="5">
        <el-input placeholder="产品名称" v-model="params.product_name" style="width: 100%" size="mini"><el-button slot="append" icon="el-icon-search" @click="searchData"></el-button></el-input>
      </el-col>
    </el-row>
    <el-table :data="catesList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="product_name" label="产品名称" width="90">
        <template slot-scope="scope">
          <el-tag>{{scope.row.product_name}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="plan_code" label="产品代码" width="150">
        <template slot-scope="scope">
          <el-tag>{{scope.row.plan_code}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="buy_mode" label="购买方式" width="150">
        <template slot-scope="scope">
          <el-tag size="mini" effect="plain" type="success" v-if="scope.row.buy_mode==1">满额赠送</el-tag>
          <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.buy_mode==2">关联商品</el-tag>
          <el-tag size="mini" effect="plain" v-else>其他</el-tag>
        </template>
      </el-table-column>
     <el-table-column prop="item_bn" label="商品" width="90" >
          <template slot-scope="scope">
              <el-button type="text" @click="handleDialogGoods(scope.row,scope.row.id)">查看商品</el-button>
          </template>
      </el-table-column>
      <el-table-column prop="premium" label="保费" width="150">
        <template slot-scope="scope">
          {{scope.row.premium}}
        </template>
      </el-table-column>
      <el-table-column prop="insured_amount" label="保额" width="180"></el-table-column>
      <el-table-column prop="remark" label="备注" width="180"></el-table-column>
      <el-table-column prop="created_at" align="center" label="提交时间" width="120" >
        <template slot-scope="scope">
          <el-tag>{{scope.row.created_at}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>
            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="content-center content-top-padded">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="params.page"
        :page-sizes="[10,20,50]"
        :total="total_count"
        :page-size="params.pageSize">
      </el-pagination>
    </div>
   <el-dialog title="添加、编辑分类" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog">
     <template>
       <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
         <el-form-item class="content-left" label="产品名称" prop="product_name" :rules="[{ required: true, message: '请输入产品名称', trigger: 'blur' }]">
           <el-input placeholder="产品名称" v-model="form.product_name"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="产品代码" prop="plan_code" :rules="[{ required: true, message: '请输入产品代码', trigger: 'blur' }]">
           <el-input  placeholder="产品代码" v-model="form.plan_code"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="购买方式">
           <el-radio-group v-model="form.buy_mode" size="small">
             <el-radio label="1" border>满额赠送</el-radio>
             <el-radio label="2" border>关联商品</el-radio>
             <el-radio label="3" border>其他</el-radio>
           </el-radio-group>
         </el-form-item>
         <el-form-item label="商城商品选择">
              <el-select v-model="relItemsShops" filterable placeholder="请输入商品货号" remote :remote-method="getItemShopsList" @change="handleItemShopsChange" multiple style="width: 55%;">
                  <el-option
                          v-for="item in relItemsShopsList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                  >
                  </el-option>
              </el-select>
              <div v-show="false">
                  <el-col>
                      <el-input v-model="form.goods_ids"></el-input>
                  </el-col>
              </div>
          </el-form-item>
         <el-form-item class="content-left" label="保费">
           <el-input  placeholder="保费" v-model="form.premium"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="保额">
           <el-input  placeholder="保额" v-model="form.insured_amount"></el-input>
         </el-form-item>
         <el-form-item class="content-center">
           <el-button type="primary" @click="saveCateData">确定保存</el-button>
         </el-form-item>
       </el-form>

     </template>
   </el-dialog>
   <el-dialog :title="goodsDialog.goodsTitle" :visible.sync="goodsDialog.goodsVisible"  :before-close="handleGoodsDialogCancel">
          <el-row
                  title="商品列表"
                  type="info"
                  description=""
                  show-icon>
          </el-row>
          <el-row :gutter="10" v-loading="goodsDialog.dialogLoading">
              <el-col :md="23">
                  <el-table ref="multipleTable" :data="goodsList" style="width: 100%" tooltip-effect="dark">
                      <!--<el-table-column type="selection" width="55" > </el-table-column>-->
                      <el-table-column prop="item_id" label="商品id" v-if="false"></el-table-column>
                      <el-table-column prop="item_name" label="商品名称" width="100">
                          <template slot-scope="scope">
                              <router-link :to="{ path: matchInternalRoute('goodsphysical_editor')+ '/' + scope.row.item_id}" class="btn-gap">{{scope.row.item_name}}</router-link>
                          </template>
                      </el-table-column>
                      <el-table-column prop="item_bn" label="商品编号">
                          <template slot-scope="scope" style="white-space: nowrap"><div v-show="false">商品id:{{scope.row.item_id}}</div>{{scope.row.item_bn}}</template>
                      </el-table-column>
                      <el-table-column prop="item_bn" label="商品来源">
                          <template slot-scope="scope">
                              <el-tag size="mini" effect="plain" type="success" v-if="scope.row.item_from=='store'">店铺</el-tag>
                              <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.item_from=='shop'">商城</el-tag>
                          </template>
                      </el-table-column>
                      <el-table-column prop="brief" label="商品简介" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="price" label="销售价格"></el-table-column>
                      <el-table-column prop="market_price" label="市场价格"></el-table-column>
                      <el-table-column prop="is_record" label="商品图片" width="90" >
                          <template slot-scope="scope">
                              <el-popover
                                      placement="right"
                                      width="240"
                                      trigger="hover" >
                                  <div style="overflow-y: scroll;overflow-x: hidden;height:240px;text-align:center;">
                                      <img  :src="v" class="goods-popover-img" style="width:92%;" v-for="v in scope.row.pics">
                                  </div>
                                  <el-button type="text" slot="reference"><img src="/static/img/icon_img.png" ></el-button>
                              </el-popover>
                          </template>
                      </el-table-column>
                      <el-table-column label="操作" min-width="100">
                          <template slot-scope="scope">
                              <el-button type="text" @click="deleteGoodsAction(scope.$index, scope.row)" class="btn-gap">删除</el-button>
                          </template>
                      </el-table-column>
                  </el-table>
                  <div class="content-center content-top-padded" v-show="false">
                      <el-pagination
                              background
                              layout="total, sizes, prev, pager, next"
                              @current-change="handleGoodsDialogCurrentChange"
                              @size-change="handleGoodsDialogSizeChange"
                              :current-page.sync="goodsDialog.goodsParams.page"
                              :page-sizes="[100,200,300]"
                              :total="goodsList.total_count"
                              :page-size="goodsDialog.goodsParams.pageSize">
                      </el-pagination>
                  </div>
              </el-col>
          </el-row>
          <span slot="footer" class="dialog-footer position-left">
            <el-button @click="goodsDialog.goodsVisible = false">取 消</el-button>
            <el-button type="primary" @click="goodsDialog.goodsVisible = false">确 定</el-button>
          </span>
      </el-dialog>
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getShopItemsDetail } from '../../../api/live'
  import { getJingzhiProductList, updateJingzhiProduct, deleteJingzhiProduct,saveJingzhiProduct,getGoods,deleteGoods,getGoodsList} from '@/api/jingzhi'
  export default {
    data () {
      return {
        isEdit: false,
        catesList: [],
        loading: false,
        total_count: 0,
        params: {
          page: 1,
          pageSize: 20,
          product_name: '',
        },
        form: {
          id: '',
          product_name: '',
          plan_code: '',
          premium: '',
          buy_mode:0,
          goods_ids:[],
          insured_amount:'',
          remark:'',
          
        },
         goodsDialog:{
            dialogLoading:true,
            goodsTitle:'',
            goodsVisible:false,
            goodsParams:{
                page:1,
                pageSize:20,
            },
        },
        goodsList:[],
        relItemsShops:"",
        relItemsShopsList:[],
        memberTagDialog: false
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      handleSizeChange (pageSize) {
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getList()
      },
      getItemShopsList(val){
          getShopItemsDetail({page: 1, pageSize: 50,id:val}).then(res => {
              this.relItemsShopsList = [];
              for (let item of res.data.data.list) {
                  this.relItemsShopsList.push({name: item.item_name, id: item.item_id})
              }
          })

      },
      handleItemShopsChange:function (val){
          this.form.goods_ids = val
      },
      preview (index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      addTemplate () { // 添加商品
        this.memberTagDialog = true
      },

      deleteGoodsAction (index, row) {
          this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              deleteGoods({goods_id:row.item_id,id:this.rowData.id}).then(response => {
                  this.ItemsList.splice(index, 1)
                  this.$message({
                      message: '删除成功',
                      type: 'success',
                      duration: 2 * 1000
                  })
              })
          }).catch(() => {
              this.$message({
                  type: 'info',
                  message: '已取消'
              })
          })
      },




      // ---获取商品（start）

      // ---编辑保险产品（start）
      editAction (index, row) { // 编辑商品弹框
        this.form = row
        this.relItemsShopsList = [];
        this.relItemsShops = [];
        getGoodsList(this.form.goods_ids).then(res=>{
          for (let item of res.data.data) {
              this.relItemsShopsList.push({id: item.item_id,name: item.item_name})
              this.relItemsShops.push(item.item_id)
          }
        })
        console.log(this.relItemsShopsList)
        console.log('*********************')
        console.log(this.relItemsShops)
        this.memberTagDialog = true
      },
      // ---编辑保险产品（end）


      handleGoodsDialogCancel(){
          this.goodsDialog.goodsVisible = false
      },
      handleGoodsDialogCurrentChange (page_num) {
          this.params.page = page_num
          this.getList()
      },
      handleGoodsDialogSizeChange (pageSize) {
          this.params.page = 1
          this.params.pageSize = pageSize
          this.getList()
      },
      async handleDialogGoods(row,id) {
        
          this.goodsList = [];
          this.rowData = row;
          this.goodsDialog.goodsTitle = '(id:'+row.id + ')' + row.product_name;
          this.goodsDialog.dialogLoading = true
          this.goodsDialog.goodsVisible = true
          this.goodsDialog.goodsParams.page = 1
          this.goodsDialog.goodsParams.pageSize = 10
          await getGoods(id).then(res=>{
              if(res.data.data){
                  this.goodsDialog.dialogLoading = false
                  this.goodsList = res.data.data;
              }
          });

      },
      // ---获取商品（end）
      getDataList () {

        this.loading = true
        getJingzhiProductList(this.params).then(response => {
          this.catesList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      handleCancelLabelsDialog () {
        this.memberTagDialog = false
      },
      deleteAction (index, row) {

        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteJingzhiProduct(row.id).then(response => {

            this.catesList.splice(index, 1)
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      getTaskTime (strDate) {
        let date = new Date(strDate)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let str = y+"-"+m+"-"+d
        return str
      },
      switchAuth(index, row) {
        let params = {
          'cate_name': row.cate_name ,
          'is_display': row.is_display ,
        }
        updateJingzhiProduct(row.comment_id,params).then(res => {
          if (res.data.data) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 2 * 1000
            })
            this.getDataList()
          }
        })
      },

      getTimeStr (date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      
      saveCateData () {
        
        this.memberTagDialog = false
        if (this.form.id) {
          
          updateJingzhiProduct(this.form.id, this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        }else{
          saveJingzhiProduct(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        }
      }
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// jingzhi_items.vue?fbe892f4